// extracted by mini-css-extract-plugin
export default {"container":"R3-z","disabled":"S3-z","snail":"T3-z","optionTitle":"U3-z","optionInfo":"V3-z","address":"W3-z"};